import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import ImageIcon from "@material-ui/icons/Image";

import Page from "src/components/Page";
import View from "./View";
import PageHeader from "../../components/PageHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const EventView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Hero Banner"
    >
      <Container maxWidth="lg">

        <PageHeader
          icon={<ImageIcon />}
          title="Hero Banner"
          subtitle="Update and manage the website hero banner"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>

      </Container>
    </Page>
  );
};

export default EventView;